<template>
<div class="top-bar pt-2">
	<b-container>
		<b-row align-v="center" class="text-center text-sm-left">
			<b-col class="pb-3 pb-sm-0">
				<Logo />
			</b-col>
			<b-col class="text-white text-md-right">
				<p class="h4">
					<a class="text-white" href="tel:0333 016 4133">
						<small>
							0333 016 4133
						</small>
					</a>
					<small>/</small>
					<a class="text-white" href="mailto:hello@thewave.com">
						<small>
							hello@thewave.com
						</small>
					</a>
				</p>
			</b-col>
		</b-row>
	</b-container>
</div>
</template>
<script>
import Logo from "@/components/icons/logo.vue";

export default {
  name: 'TopBar',
  components: {
    Logo,
  }
};
</script>
